export default function Style(){
  return (
    <style>
      {`
       .fs-14-21{
    font-size: 13px !important;
    line-height: 20px !important;
}
.fw-400{
    font-weight: 400 !important;
}
@media screen and (min-width: 1534px) {
   
.fs-14-21 {
  font-size: 14px !important;
  line-height: 21px !important;
}
}

        `}
    </style>
  );
}
